import IAuthUserRepository from 'domain/interfaces/repositories/IAuthUserRepository'

export const recoverPasswordAuthUserCommand = (
  repository: IAuthUserRepository,
  identificationNumber: string,
) => {
  return repository.recoverPassword(identificationNumber)
}
